import { render, staticRenderFns } from "./task_topic.vue?vue&type=template&id=d5c91e94&scoped=true&"
import script from "./task_topic.vue?vue&type=script&lang=js&"
export * from "./task_topic.vue?vue&type=script&lang=js&"
import style0 from "./task_topic.vue?vue&type=style&index=0&id=d5c91e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c91e94",
  null
  
)

export default component.exports